import(/* webpackMode: "eager" */ "/repo/apps/trading-arena/app/page.tsx");
